module.exports = __webpack_public_path__ + "static/media/expansion_dd.df8f812e.svg";